export interface LogoProps {
  className?: string;
}

export function Logo({ className = undefined }: LogoProps) {
  return (
    <svg
      className={className || 'block w-full'}
      viewBox="0 0 271 123"
      width="271"
      height="123"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M205.577 75.7615C205.577 98.2429 208.391 107.504 215.332 114.121C220.96 119.574 228.708 122.219 238.151 122.25C247.738 122.25 255.348 119.574 261.133 114.121C268.081 107.504 270.888 98.2742 270.888 75.7615V46.495C270.888 24.0073 268.081 14.7458 261.133 8.12959C255.348 2.64524 247.738 0 238.151 0C228.727 0 220.96 2.67651 215.332 8.12959C208.391 14.7458 205.577 23.9823 205.577 46.495V75.7615ZM246.087 80.8831H246.068C246.068 93.1213 246.068 101.057 238.151 101.057C230.378 101.057 230.378 93.1213 230.378 80.8831V41.3671C230.378 29.1289 230.378 21.1932 238.151 21.1932C246.087 21.1932 246.087 29.1283 246.087 41.3655V80.8831Z"
      />
      <path d="M0 20.5367V34.9198H16.2091V108.167L16.0405 120.237H41.1731L41.0107 108.167V13.4264L41.1731 1.35083H25.3018C23.138 6.97275 15.3774 14.9085 0 20.5367Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.7425 96.2854V108.167L83.58 120.211H107.556L107.387 108.142V96.2604H120.119V75.261H107.387V14.0827L107.556 2.01343H81.0975L48.1914 73.4412V96.2854H83.7425ZM83.7425 56.4129V75.261H69.0406L78.6462 50.791C79.3091 49.14 83.2799 39.2407 83.9428 36.7393H84.5681C84.2367 40.0411 83.7425 50.1593 83.7425 56.4129Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M162.683 108.167V96.2854H127.138V73.4412L160.038 2.01343H186.497L186.328 14.0827V75.261H199.06V96.2604H186.328V108.142L186.497 120.211H162.52L162.683 108.167ZM162.683 75.261V56.4129C162.683 50.1593 163.184 40.0411 163.515 36.7393H162.852C162.233 39.0752 158.729 47.8629 157.733 50.3597L157.561 50.791L147.969 75.261H162.683Z"
      />
    </svg>
  );
}
